import React, { PureComponent } from 'react';
import strings from 'helper/localization/localization';

export default class YearOfBirthSelect extends PureComponent {
  constructor(props) {
    super(props);

    // Properties
    this.yearOfBirth = this.props.yearOfBirth;
    this.updateYear = this.props.updateYear;

    // Bindings
    this.updateYearOfBirth = this.updateYearOfBirth.bind(this);
  }

  updateYearOfBirth(event) {
    this.updateYear(Number(event.target.value));
  }

  render() {
    // Create year options
    const years = [];
    for (let i = 2002; i > 1910; i -= 1) {
      years.push(<option value={i} key={i}>{i}</option>);
    }

    return (
      <div className="form-group">
        <label htmlFor="account--yob">{strings.yearOfBirth}</label>
        <select
          className="form-control custom-select"
          id="account--yob"
          defaultValue={this.yearOfBirth}
          onChange={this.updateYearOfBirth}
        >
          {years}
        </select>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/personalDetails/YearOfBirthSelect.jsx